import { types } from "./action";

const initialState = {
  data: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.SET_BRANDING:
      return {
        ...state,
        data: action.payload || null,
      };
    case types.UPDATE_BRANDING:
      return {
        ...state,
        data: action.payload ? { ...(state.data || {}), ...action.payload } : state.data,
      };
    default:
      return state;
  }
};
